






































import {Component, Vue} from 'vue-property-decorator'
import {Getter, Mutation, Action} from 'vuex-class'
import Modal from '@/components/common/Modal.vue'
import {Service, ServiceType, Location} from '@/store/types'

@Component({
  components: {
    Modal,
  },
})
export default class ServiceNewItemModal extends Vue {
  @Getter('activeServiceType') public activeServiceType!: ServiceType
  @Getter('location') public location!: Location
  @Mutation('setServiceNewItemModal') public setServiceNewItemModal!: any
  @Action('addNewService') public addNewService!: any

  public params: any = {
    distance: undefined,
    flights: undefined,
    num_of_hours: undefined,
    num_of_pallets: undefined,
    amount: undefined,
  }
  public addService() {
    const data: any = {
      additional_service_id: this.activeServiceType.id,
      lead_location_id: this.location.id,
      params: this.params,
    }
    this.addNewService(data).then((response: Service) => {
      this.setServiceNewItemModal(false)
    })
  }
  public serviceName(service: string) {
    return service.toLowerCase().split(' ').join('-')
  }

  public mounted() {
    if (this.activeServiceType.name === 'Long Carry') {
      this.params.distance = 100
    }
    if (this.activeServiceType.name === 'Stair Carry') {
      this.params.flights = 1
    }
    if (this.activeServiceType.name === 'Waiting Time') {
      this.params.num_of_hours = 1
    }
    if (this.activeServiceType.name === 'Palletizing') {
      this.params.num_of_pallets = 0
    }
    if (this.activeServiceType.class_name === 'Manual') {
      this.params.amount = 0
    }
  }
}
